import * as React from "react";
import { connect } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HooplaUser } from "types";
import { ApplicationState } from "stores";
import { fetchCookieUser } from "stores/user";
import { FormattedMessage } from "react-intl";
import Header from "components/Header";
import Loading from "components/Loading";
import NewLogin from "components/NewLogin";

import Login from "../Login";
import Tickets from "../Tickets";
import Privacy from "../Privacy";
import Settings from "../Settings";

import * as styles from "./styles";

interface IProps {
  user: HooplaUser;
  loading: boolean;
  loginLoading: boolean;
  loginError: boolean;
  loginSuccess: boolean;
  noLogin: boolean;
  loginRequest: boolean;
  loginErrorMessage: string;

  fetchCookieUser: () => void;
}

const Application: React.FC<IProps> = (props) => {
  React.useEffect(() => {
    if (window.location.pathname !== "/login/" && window.location.pathname !== "/login") {
      props.fetchCookieUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (props.loading || props.loginLoading) {
    return (
      <div className={styles.loadingContainer}>
        <Loading size="large" />
      </div>
    );
  }

  if (!props.user) {
    return (
      <BrowserRouter>
        <React.Fragment>
          {!props.loginError && (
            <Routes>
              <Route path={"/login"} element={<NewLogin />} />
            </Routes>
          )}
          <Header />
          <Login />
          {props.loginError && !props.loginRequest && (
            <div className={styles.error}>
              <FormattedMessage id={"containers.App.error"} />
            </div>
          )}
        </React.Fragment>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <React.Fragment>
        <Header user={props.user} />
        <div className={styles.contentContainer}>
          <div className={styles.content}>
            <Routes>
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/" element={<Tickets />} />
            </Routes>
          </div>
        </div>
      </React.Fragment>
    </BrowserRouter>
  );
};

export default connect(
  (state: ApplicationState) => {
    return {
      loading: state.user.fetching,
      user: state.user.userData,
      noLogin: !state.authWithNonce.requested,
      loginSuccess: state.authWithNonce.requested && state.authWithNonce.success,
      loginLoading: state.authWithNonce.requested && state.authWithNonce.requesting,
      loginError:
        state.authWithNonce.requested &&
        !state.authWithNonce.requesting &&
        !state.authWithNonce.success,
      loginRequest: state.loginRequest.requested,
      loginErrorMessage: state.authWithNonce.error,
    };
  },
  { fetchCookieUser },
)(Application);
